import methods from './../methods'
import _filters from './../_filters'
import moment from 'moment'
import getLangFromUrl from './getLangFromUrl'
import helper from './../helper'
import api from './../api'
import Vue from 'vue'

export default {

  searchFormSubmit () {
    // this.detailedSearch = false
    this.searchFilters.favorites = 0
    this.$nextTick(() => {
      this.progressSearching = true
      this.$store.dispatch('goToFirstPage')
      this.searchObjects(true)
      // window.scrollTo(0, 0)
      // this.scrollToBeginningOfListResult()
    })
  },

  getLangFromUrl: getLangFromUrl,

  toggleFavorite (object) {
    this.$store.dispatch('toggleFavorite', object)
  },

  isFavorite (object) {
    return this.favorites.includes(object.id)
  },

  resetPrice () {
    this.bookNowObject.bookingPrice = null
  },

  getObjectPrice () {
    // First get object info
    this.priceObject = {}
    this.bookNowAvailable = false
    this.loadingObjectInfo = true

      let filters = []
      let priceObject = JSON.parse(JSON.stringify(this.selectedObject))
      if (this.searchFilters.dateStart && this.searchFilters.dateEnd) {
        filters.push({
          key: 'dateStart',
          value: helper.dateToYMD(this.searchFilters.dateStart)
        })
        filters.push({
          key: 'dateEnd',
          value: helper.dateToYMD(this.searchFilters.dateEnd)
        })
        filters.push({
          key: '_id',
          value: this.selectedObject._id
        })
        api.getListItems('objects', filters).then(result => {
          if (result && result.items && result.items[0]) {
            // TODO - refactor
            priceObject.bookingPrice = result.items[0].bookingPrice
            priceObject.bookingDays = result.items[0].bookingDays
            priceObject.minDays = result.items[0].minDays
            priceObject.dayPrices = result.items[0].dayPrices
            priceObject.bookingMinPeriodPrice = result.items[0].bookingMinPeriodPrice
            priceObject.longTermRentCsrFee = result.items[0].longTermRentCsrFee
            this.bookNowAvailable = true
          } else {
            priceObject = {}
            this.bookNowAvailable = false
          }
          this.priceObject = JSON.parse(JSON.stringify(priceObject))
          this.loadingObjectInfo = false
        })
      } else {
        this.priceObject = {}
        this.loadingObjectInfo = false
      }
  },

  scrollToBeginningOfListResult () {
    if (!this.$vuetify.breakpoint.smAndDown) { return }
    if (this.searchFilters.page === 1 && this.isHomepage) { return }
    this.$nextTick(() => {
      this.$vuetify.goTo('#objects-list', {
        duration: 700,
        easing: 'easeInOutCubic',
        offset: 58
      })
    })
  },

  scrollToBeginningOfArticle () {
    if (!this.$vuetify.breakpoint.smAndDown) { return }
    const timePassedFromSiteOpen = (+new Date() - this.openTs)
    if (timePassedFromSiteOpen < 2000) { return } // Just opened page
    this.$nextTick(() => {
      this.$vuetify.goTo('#content-area', {
        duration: 700,
        easing: 'easeInOutCubic',
        offset: 48
      })
    })
  },

  mobileShare () {
    if (navigator.share) {
      navigator.share({
        title: document.title,
        text: this.$i18n.t('shareMessage'),
        url: document.URL,
      })
        .then(() => console.log('Successful share'))
        .catch((error) => console.log('Error sharing', error));
    } else {
      // console.log('no-navigator.share')
    }
  },

  setContentAreaWidth () {
    this.$nextTick(() => {
      let contentEl = document.getElementById('content-area')
      if (contentEl && contentEl.clientWidth) {
        this.contentAreaWidth = contentEl.clientWidth - 22
      }
    })
  },

  navigateToObjectBookingForm (object) {
    this.$router.push({ path: this.objectBookingLink(object) })
    window.scrollTo(0, 0)
  },

  capitalize (s) {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
  },

  /*showBookNowForm (object) {
    this.$router.push({ path: '/' + this.lang + '/booknow/' + object._id })
    window.scrollTo(0, 0)
  },*/

  showPageId (page) {
    let id = page._id
    const menuInfo = this.pagesById[id]
    if (menuInfo.listSearchQuery) {
      const url = '/'  + this.lang + '/search/q/?' + menuInfo.listSearchQuery
      this.$router.push({ path: url })
      window.scrollTo(0, 0)
    } else if (menuInfo.externalLink) {
      window.open(menuInfo.externalLink, "_blank")
    } else {
      let showId = id
      let showPage = menuInfo
      if (menuInfo.articleId) {
        showId = menuInfo.articleId
        showPage = this.pagesById[showId]
      }
      this.pageId = showId
      this.$router.push({ path: '/' + (showPage['seoName_' + this.lang] || showId) + '_' + this.lang + '_page.html' })
      if (!this.$vuetify.breakpoint.smAndDown) {
        window.scrollTo(0, 0)
      } else {
        this.scrollToBeginningOfArticle()
      }
    }
    this.showRightMenu = false
  },

  objectLink (object) {
    let linkQuery = this.searchFilters.dateEnd && this.searchFilters.dateStart
      ? '?dateStart=' + this.searchFilters.dateStart + '&dateEnd=' + this.searchFilters.dateEnd
      : ''
    return '/' + (object.seoName || object._id) + '_' + this.lang + '_object.html' + linkQuery
  },

  objectLinkWithLang (object, lang) {
    return '/' + (object.seoName || object._id) + '_' + lang + '_object.html'
  },

  objectBookingLink (object) {
    return '/' + (object.seoName || object._id) + '_' + this.lang + '_object.html' + '?booknow=' + +new Date + '&dateStart=' +
    this.searchFilters.dateStart + '&dateEnd=' + this.searchFilters.dateEnd
  },

  objectFullLink (object) {
    return location.protocol+'//'+location.hostname + '/' + (object.seoName || object._id) + '_' + this.lang + '_object.html'
  },

  getObjectDescription (object) {
    if (!object) {
      return ''
    }

    const objectType = this.capitalize(object.exactType && object.exactType['typeName_' +  this.lang] ||
        object.type['typeName_' +  this.lang])

    const bedrooms = object.bedrooms + ' ' + (object.bedrooms > 1 ? this.$i18n.t('magamistoaga') : this.$i18n.t('magamistuba'))
    const bathroom = object.bathrooms + ' ' + (object.bathrooms > 1 ? this.$i18n.t('vannitoaga') : this.$i18n.t('vannituba'))

    let texts = []
    let intro = []
    intro.push(bedrooms)
    if (object.bathrooms > 0) {
      intro.push(bathroom)
    }
    if (object.floors > 0) {
      intro.push(object.floors + ' ' + this.$i18n.t('floors'))
    }
    texts.push(intro.join(', ') + ' ' + (object.squareMeters ? object.squareMeters + ' m2 ' : '') +
      objectType.toLowerCase() + ' ' + object.objectName + ', ' + object.address)

    // Price
    texts.push( this.$i18n.t('alates') + ' ' + object.dayPrice + '€ / ' + this.$i18n.t('öö'))

    // Top features
    const topFeatuersToLookFor = [
      '5bc97e30a5b59924f643070b', // sea view
      '5d7749a7a7a2341edab78fe1', // mountain view
      '5bc97b9da5b59924f64306f4', // pool
      '5bc97ca4a5b59924f64306fe', // kids pool
      '5bc97e0fa5b59924f643070a', // beach
      '5bc97cbca5b59924f64306ff', // conditioner
      '5bc97cd7a5b59924f6430700', // kids playground
      '5d7747b3a7a2341edab78fde', // sauna
      '5d78e42c1428214386462be7', // mullivann
      '5bc97ae1a5b59924f64306f1', // terrass
    ]

    const maxFeatures = 5
    let topFeatures = []
    topFeatuersToLookFor.forEach(id => {
      if (this.featuresList[id] && object.features[id] && object.features[id].checked && topFeatures.length < maxFeatures) {
        topFeatures.push(this.featuresList[id]['name_' + this.lang])
      }
    })
    let lastFeature = topFeatures.pop()
    if (topFeatures.length > 0) {
      texts.push(this.capitalize(topFeatures.join(', ') + ' ' + this.$i18n.t('and') + ' ' + lastFeature))
    }

    // 5bc97befa5b59924f64306f8 // airport
    // 5bc97c0ba5b59924f64306f9 // transport

    // Distances
    if (object.features['5bc97befa5b59924f64306f8'] && object.features['5bc97befa5b59924f64306f8'].checked &&
      object.features['5bc97c0ba5b59924f64306f9'] && object.features['5bc97c0ba5b59924f64306f9'].checked &&
      this.featuresList['5bc97c0ba5b59924f64306f9']
    ) {
      texts.push(this.featuresList['5bc97c0ba5b59924f64306f9']['name_' + this.lang] + ': ' +
        object.features['5bc97c0ba5b59924f64306f9'].distance + ', ' + this.featuresList['5bc97befa5b59924f64306f8']['name_' + this.lang] + ': ' +
          object.features['5bc97befa5b59924f64306f8'].distance)
    }

    const metaDescripion = texts.join('. ')
    return metaDescripion
  },

  getObjectFistImagePreviewFullLink (object) {
    if (!object || !object.objectImages || !object.objectImages[0]) { return '' }
    return 'https://s3.eu-central-1.amazonaws.com/img.costasolrent.com/objectImages/preview/' + object.objectImages[0].image
  },

  getMetaTags () {
    return {
      title: this.metaTitle,
      meta: [
        {
          name: 'description',
          content: this.metaDescription
        },
        {
          rel: 'canonical',
          href: this.metaUrl
        },
        {
          property: 'og:type',
          content: this.metaType
        },
        {
          property: 'og:title',
          content: this.metaTitle
        },
        {
          property: 'og:description',
          content: this.metaDescription
        },
        {
          property: 'og:image',
          content: this.metaImage
        },
        {
          property: 'og:url',
          content: this.metaUrl
        },
        {
          property: 'og:site_name',
          content: this.metaSiteName
        },
        {
          name: 'twitter:title',
          content: this.metaTitle
        },
        {
          name: 'twitter:description',
          content: this.metaDescription
        },
        {
          name: 'twitter:image',
          content: this.metaImage
        }
      ]
    }
  },

  formatYMD (date) {
    let d = date.split('.')
    return d[2] + '-' + d[1] + '-' + d[0]
  },

  updatePickerDate (payload) {
    if (payload.field === 'dateStart') {
      if (this.showSearchPickerFor) {
        this.showSearchPickerFor = 'dateEnd'
      } else {
        this.showBookingPickerFor = 'dateEnd'
      }
    } else {
      this.showSearchPickerFor = null
      this.showBookingPickerFor = null
    }
    if (payload.field && payload.value) {
      this.searchFilters[payload.field] = payload.value
      // end date before start date
      if (payload.field === 'dateEnd' &&
        this.searchFilters.dateStart &&
        moment(this.formatYMD(this.searchFilters.dateStart)) >=
        moment(this.formatYMD(payload.value))
      ) {
          this.searchFilters.dateStart = ''
          // start date after end date
      } else if (payload.field === 'dateStart' &&
        this.searchFilters.dateEnd &&
        moment(this.formatYMD(payload.value)) >=
        moment(this.formatYMD(this.searchFilters.dateEnd))
      ) {
        this.searchFilters.dateEnd = ''
      }
      if (payload.value) {
        // start date before today
        if (payload.field === 'dateStart' &&
          moment(this.formatYMD(payload.value)).add(1, 'days') < moment()) {
          this.searchFilters.dateStart = moment().add(1, 'days').format('DD.MM.YYYY')
        }
        // end date before today
        if (payload.field === 'dateEnd' &&
          moment(this.formatYMD(payload.value)) < moment()
        ) {
          this.searchFilters.dateEnd = moment().add(2, 'days').format('DD.MM.YYYY')
        }
      }
    } else if (payload.field) {
      this.searchFilters[payload.field] = ''
    }
  },

  goToFavorites () {
    if (this.searchFilters.favorites === 1 && this.$route.name !== 'object') {
      this.searchFilters.favorites = 0
      this.$router.push({ path: '/' + this.lang })
    } else {
      this.$router.push({ path: '/' + this.lang + '/search/q/?favorites=1' })
    }
  },

  searchObjects (goToSearchPage = false) {
    if (goToSearchPage) {
      this.$router.push({ path: '/'  + this.lang + '/search/q/?' + this.getSearchQuery() }).catch(() => {})
    }
    // Allow router change to change isHomepage
    this.$nextTick(() => {
      if (this.filtersHash && this.filtersHash === _filters.getHash(this.$store.state)) {
        // Dummy loader for the user to show that list is loading,
        // but actually using cached data because search conditions are same
        // can't do this, otherwise back button not working to position y
        if (this.progressSearching) {
          setTimeout(() => {
            this.progressSearching = false
          }, 100)
        }
        return
      }
      this.progressSearching = true
      this.$nextTick(() => {
        this.$store.dispatch('findObjects').then(items => {
          this.progressSearching = false
          this.$nextTick(() => {
            if (!this.goToSingleFoundObect(items)) {
              this.scrollToBeginningOfListResult()
            }
          })
        })
      })
    })
  },

  goToSingleFoundObect (items) {
    if (items && items.length === 1 && this.searchFilters.csrId) {
      // If searched by csr ID and found only one, redirect to that object
      this.$nextTick(() => {
        this.$router.push({ path: this.objectLink(items[0]) }).catch(() => {})
      })
      return true
    }
    return false
  },

  getSearchQuery () {
    return encodeURI(Object.keys(this.searchFilters).map(filterName => {
      return filterName + '=' + this.searchFilters[filterName]
    }).join('&'))
  },

  getBookingFormInfoFromUrl () {
    if (this.$route.query.dateStart && this.$route.query.dateEnd && this.$route.query.dateEnd !== 'null') {
      Vue.set(this.searchFilters, 'dateStart', this.$route.query.dateStart)
      Vue.set(this.searchFilters, 'dateEnd', this.$route.query.dateEnd)
    }
    if (this.$route && this.$route.query && this.$route.query.booknow) {
      this.showBookNowForm = true
    } else {
      this.showBookNowForm = false
    }
  },

  parseSearchFiltersFromQuery () {
    let filters = this.cloneObject(this.searchFilters)
    Object.keys(filters).forEach(name => {
      let val = this.$route.query[name]
      if (parseInt(val).toString() === val) {
        val = parseInt(val)
      } else if (val === 'null') {
        val = null
      }
      if (val !== null && val !== undefined) {
        filters[name] = val
      } else {
        filters[name] = this.filterDefaultValues[name]
      }
    })
    this.searchFilters = filters
  },

  cloneObject (obj) {
    if (!obj) {
      return {}
    }
    return JSON.parse(JSON.stringify(obj))
  },

  changeLang (lang) {
    let newUrl
    let urlParts = this.$route.fullPath.split('_')
    let baseUrlParts = this.$route.path.split('_')
    if (baseUrlParts.length > 2) {
      // Switch lang
      urlParts[urlParts.length - 2] = lang
      newUrl = urlParts.join('_') // + this.$route.fullPath.substr(4)
      if (this.$route.name === 'article') {
        let articleSeoName = urlParts.filter((urlPart, index) => index <= urlParts.length - 3).join('_').replace('/', '')
        let article = this.pagesBySeoName[articleSeoName]
        const articleSeoUrlPart = this.pagesBySeoName[articleSeoName]['seoName_' + (lang === 'ru' ? 'en' : lang)]
        if (article && articleSeoUrlPart) {
          newUrl = '/' + articleSeoUrlPart + '_' + lang + '_page.html'
        } else {
          newUrl = '/' + lang // No article in that language, direct to home page
        }
      }
    } else {
      newUrl = '/' + lang + '/' + this.$route.fullPath.substr(4)
    }
    this.$router.push({ path: newUrl })
    // this.$i18n.locale = lang
  },

  goHomeAndClearSearch () {
    if (this.showArticleOnly) { return }
    this.goHome()
    this.clearSearch()
  },

  clearSearch () {
    this.searchFilters = JSON.parse(JSON.stringify(this.filterDefaultValues))
  },

  goHome () {
    this.$router.push({ path: '/' + this.lang })
    this.showRightMenu = false
    this.showLeftMenu = false
    window.scrollTo(0, 0)
  }
}

// alt tags for images
// https://www.advancedwebranking.com/blog/meta-tags-important-in-seo/
